import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { WidgetParent } from "../../class/widget-parent";
import { ComponentAdapterFactory } from "../../class/adapters/component-adapter-factory";
import { ComponentAdaperAlarm } from "../../class/adapters/component-adapter-alarm";
import { SmartPaletteGeneral } from "../../class/smart-palette";
import { IonIcon, IonButton } from "@ionic/angular";
import type { Animation } from '@ionic/angular';
import { debounceTime, filter, take, tap } from "rxjs/operators";
import { Subscription } from "rxjs";
import { IconHelper } from "../../class/icon-helper";
import { SmartComponentSpinnerComponent } from "../smart-component-spinner/smart-component-spinner.component";
import { ErrorLoadingWidgetComponent } from "../error-loading-widget/error-loading-widget.component";

@Component({
    selector: "app-widget-alarm",
    templateUrl: "./widget-alarm.component.html",
    styleUrls: ["./widget-alarm.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonIcon, SmartComponentSpinnerComponent, ErrorLoadingWidgetComponent]
})
export class WidgetAlarmComponent extends WidgetParent<ComponentAdaperAlarm> {
  private _iconAlarmOn = "";
  private _iconAlarmOff = "";
  private _animation: Animation = null;
  private _widgetIsDisplayableSub: Subscription = null;
  private _isAnimationPlaying: boolean = false;

  public iconAlarmState: string = "";

  @ViewChild("alarmICon", { read: ElementRef }) _alarmICon: ElementRef;

  constructor() {
    super();

    this._iconAlarmOn = IconHelper.getIconsForAlarm().on;
    this._iconAlarmOff = IconHelper.getIconsForAlarm().off;


    this.iconAlarmState = this._iconAlarmOff;
  }

  ngAfterViewInit() {

    this._widgetIsDisplayableSub = this._widgetIsDisplayable.pipe(
      filter((isReady) => isReady),
      debounceTime(500),
    ).subscribe((isReady) => {
      this._animation = this._animationController
        .create("alarm-animation")
        .addElement(this._alarmICon.nativeElement)
        .duration(1500)
        .iterations(Infinity)
        .keyframes([
          { offset: 0, opacity: '0.4' },
          { offset: 0.5, opacity: '1' },
          { offset: 1, opacity: '0.4' },
        ]);

      if (this._isAnimationPlaying) {
        this._animation.play();
      } else {
        this._animation.stop();
      }
    });
  }


  /**
   * Add class "turn-on" to button if alarm is on
   * @returns boolean
   */
  public toggleClassForButton(): boolean {
    return this.iconAlarmState === this._iconAlarmOn ? true : false;
  }

  /**
   * When the button is clicked turn on/off alarm
   */
  public onClickSwitchAlarm(): void {
    this.switchAlarm();
  }

  /**
   * IF the "ALARM_RESET" skill is definied, switch alarm on/off and send command "0" via mqtt.
   */
  private switchAlarm(): void {

    // If alarm reset is active send 0
    if (this.componentAdapter.AlarmReset) {
      const instanceGUID: string = this.componentAdapter.AlarmReset.instanceGUID;
      const address: string = this.componentAdapter.AlarmReset.address;

      this.sendAddressCommand(instanceGUID, address, "0");
    }

  }

  protected setWidgetSmartPalette(): SmartPaletteGeneral {
    let widgetSmaertPalette = new SmartPaletteGeneral();

    return widgetSmaertPalette;
  }

  protected onComponentLoad(): void { }

  protected onComponentDestroy(): void {
    this._animation?.stop();
    this._animation = null;
    this._widgetIsDisplayableSub?.unsubscribe();
  }

  protected onSmartComponentErrorLoading(): void { }

  protected onSmartComponentSuccessLoaded(): void | boolean {
    const factory = new ComponentAdapterFactory();
    this.componentAdapter = factory.createComponentAdapter(
      this._listSmartComponentSkills,
      ComponentAdaperAlarm
    );

    this.titleWidget = this.componentAdapter.Name;

    //If component title is empty show error loading component
    if (!this.titleWidget) {
      return this._errorLoading = true;
    }
  }

  protected onAddressValueChange(instanceGUID: string, address: string, value: string): void {

    this.handleAlarmStateChange(instanceGUID, address, value);

  }

  /**
   * Change the state of the icon according to value and Inverted skill
   */
  private handleAlarmStateChange(instanceGUID: string, address: string, value: string): void {

    // Update the icon alarm state based on the value of the address
    if (this.componentAdapter?.AlarmState && instanceGUID === this.componentAdapter.AlarmState.instanceGUID && address === this.componentAdapter.AlarmState.address) {
      //If Inverted is true: On state = 0, Off state = 1
      //If Inverted is false (default value): On state = 1, Off state = 0
      if (value === "1" && !this.componentAdapter.Inverted || value === "0" && this.componentAdapter.Inverted) {
        this.iconAlarmState = this._iconAlarmOn;

        this._isAnimationPlaying = true;
        if (this._animation) {
          this._animation?.play();
        }

      } else {

        this._isAnimationPlaying = false;
        if (this._animation) {
          this._animation?.stop();
        }

        this.iconAlarmState = this._iconAlarmOff;
      }
    }

  }
}
